import { BeelineResult } from '../beelineLp/BeelineLanding';

export default function Beeline1Success() {
  return <BeelineResult lpKey="beeline1" outcome="success" variant={1} />;
}
